<template>
    <div class="home-cats">
        <div class="cat-items">
            <div class="cat-item" v-for="cat in cats" @click="toCats(cat.id)">
                <div style="height: 55px">
                    <img :src="cat.imgUrl" style="width: 50px;height: 50px;margin: auto"/>
                </div>
                <span style="height: 23px;line-height: 23px;display: block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden">{{cat.categoryName}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        data() {
            return {
                deptId: '',
                phone: '',
                cats: [],
            };
        },
        async created() {
            this.deptId = getDeptId()
            this.getCats()
        },
        methods: {
            async getCats() {
                let data = {
                    deptId: this.deptId,
                    catType: 0,
                }
                let res = await this.$get("/spm/getHomeCats", data)
                this.cats = res.list
            },
            toCats(id) {
                this.$router.push('/ptcats/' + this.deptId + '/' + id)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .home-cats {
        height: 100%;
    }

    .cat-items {
        display: flex;
        flex-flow: row wrap;
        font-size: 10px;
        text-align: center;
    }

    .cat-item {
        box-sizing: border-box;
        height: 90px;
        padding: 8px 8px 5px 8px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc(100% / 5); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 5);
        max-width: calc(100% / 5);
    }

</style>
